import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PoliticaPrivacidade() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-background-100 overflow-hidden">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 text-center">
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-xs tracking-[0.2em] uppercase text-primary-400 font-label"
            >
              Legal
            </motion.span>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="font-heading text-4xl md:text-6xl text-foreground-950 mt-4 leading-[1.05]"
            >
              Política de<br />
              <span className="italic font-light">Privacidade.</span>
            </motion.h1>
          </div>
        </section>

        <section className="relative bg-background-50 py-16 md:py-24">
          <div className="max-w-[800px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="prose prose-sm max-w-none text-foreground-600 space-y-6">
              <p>
                A Femme Vie valoriza a privacidade e a segurança dos dados pessoais de suas pacientes e visitantes. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).
              </p>

              <h2 className="font-heading text-2xl text-foreground-950 mt-10">1. Quais dados coletamos</h2>
              <p>Podemos coletar as seguintes informações quando você interage com nossa clínica:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Nome completo</li>
                <li>CPF</li>
                <li>Data de nascimento</li>
                <li>Endereço</li>
                <li>Telefone e e-mail</li>
                <li>Dados de saúde e histórico médico (apenas no contexto da consulta e tratamento)</li>
                <li>Dados de navegação em nosso site (cookies, endereço IP)</li>
              </ul>

              <h2 className="font-heading text-2xl text-foreground-950 mt-10">2. Para que utilizamos seus dados</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>Agendamento e realização de consultas e exames</li>
                <li>Manutenção de prontuário médico</li>
                <li>Comunicação sobre consultas, resultados de exames e orientações médicas</li>
                <li>Envio de comunicações informativas (com seu consentimento)</li>
                <li>Cumprimento de obrigações legais e regulatórias</li>
              </ul>

              <h2 className="font-heading text-2xl text-foreground-950 mt-10">3. Compartilhamento de dados</h2>
              <p>
                Seus dados pessoais e de saúde são tratados com absoluto sigilo. Não compartilhamos suas informações com terceiros, exceto quando necessário para a prestação do serviço (como laboratórios de análises clínicas, mediante sua autorização) ou para cumprimento de obrigações legais.
              </p>

              <h2 className="font-heading text-2xl text-foreground-950 mt-10">4. Armazenamento e segurança</h2>
              <p>
                Utilizamos medidas técnicas e organizacionais de segurança para proteger seus dados contra acessos não autorizados, perda, alteração ou destruição. Seus registros médicos são armazenados em sistemas seguros e de acesso restrito às profissionais de saúde envolvidas no seu atendimento.
              </p>

              <h2 className="font-heading text-2xl text-foreground-950 mt-10">5. Seus direitos</h2>
              <p>De acordo com a LGPD, você tem direito a:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Confirmar a existência de tratamento de seus dados</li>
                <li>Acessar seus dados</li>
                <li>Corrigir dados incompletos ou desatualizados</li>
                <li>Solicitar a exclusão de dados desnecessários</li>
                <li>Revogar consentimento a qualquer momento</li>
              </ul>

              <h2 className="font-heading text-2xl text-foreground-950 mt-10">6. Cookies</h2>
              <p>
                Nosso site pode utilizar cookies para melhorar sua experiência de navegação. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar algumas funcionalidades do site.
              </p>

              <h2 className="font-heading text-2xl text-foreground-950 mt-10">7. Contato do Encarregado de Dados</h2>
              <p>
                Para exercer seus direitos ou esclarecer dúvidas sobre esta política, entre em contato através do e-mail: contato@clinicafemmevie.com.br ou pelo telefone (85) 3045-8454.
              </p>

              <p className="text-xs text-foreground-500 mt-12">
                Última atualização: Julho de 2026. Esta política pode ser alterada a qualquer momento. Recomendamos a consulta periódica.
              </p>
            </div>

            <div className="mt-12 text-center">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar ao início
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}